export const numberHasDecimal = (number, length = 2) => {
  if (!number) {
    return "0.00";
  }
  let numberPrint = number + "";
  const hasDecimal = number % 1 !== 0;
  if (!hasDecimal && length > 0) {
    numberPrint = numberPrint + ".00";
  } else {
    const numberFloat = parseFloat(numberPrint);
    numberPrint = numberFloat.toFixed(length);
    // const decimalPart = numberPrint.split(".")[1];
    // const padding = Array(length + 1 - decimalPart.length).join("0");
    // numberPrint = numberPrint + padding;
  }
  return numberPrint;
};

export const emailValidation = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
